import React from 'react';
import DashboardShell from './DashboardShell';
import {useDashboardData} from './useDashboardData';
import {FunnelStages, DonutBreakdown, TrendLineChart} from '../../../components/charts';

type PipelineData = {
    stages: {label: string; value: number}[];
    status_breakdown: {name: string; value: number}[];
    requests_by_day: {date: string; count: number}[];
};

/** Collaboration Pipeline (P1) - execution_strategy_activity_tracker.md
 * Phase 4.2. The funnel from a raw service request through to an active
 * collaboration - the platform's core business workflow. */
const CollaborationPipelineDashboard: React.FC = () => {
    const {data, loading, error} = useDashboardData<PipelineData>('/admin-dashboard/dashboards/collaboration-pipeline/');

    return (
        <DashboardShell
            title="Collaboration Pipeline"
            subtitle="From service request to active collaboration"
            loading={loading}
            error={error}
        >
            {data && (
                <div className="row g-3">
                    <div className="col-lg-5">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">Pipeline Stages</span></div>
                            <div className="uz-panel-body">
                                <FunnelStages stages={data.stages}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">Requests by Status</span></div>
                            <div className="uz-panel-body">
                                <DonutBreakdown data={data.status_breakdown}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">New Requests (30d)</span></div>
                            <div className="uz-panel-body">
                                <TrendLineChart data={data.requests_by_day} xKey="date" yKey="count" height={200}/>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </DashboardShell>
    );
};

export default CollaborationPipelineDashboard;
